import ConstantHelper from "../../Helpers/ConstantHelper";

const ComboPackagesData = [
  {
    id: "1",
    title: "Professional Combo Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "1400",
    actualPrice: "2800",
    featuresList: [
      { feature: "3 Initial Logo Concepts" },
      { feature: "8 Dedicated Designers" },
      { feature: "Icon Design" },
      { feature: "2 Free Custom Stationary Designs" },
      { feature: "MS Word Letterhead" },
      { feature: "Trifold Brochure Design" },
      { feature: "Presentation Folder Design" },
      { feature: "Conceptual and Dynamic Liquid Website " },
      { feature: "Team of Expert Designers & Developers" },
      { feature: "Mobile Responsive" },
      { feature: "Online Reservation/Appointment Tool (Optional)" },
      { feature: "Custom Forms" },
      { feature: "Lead Capturing Forms (Optional)" },
      { feature: "Newsfeed Integration" },
      { feature: "Social Media Integration" },
      { feature: "15 Stock images" },
      { feature: "8 Unique Banner Designs" },
      { feature: "jQuery Sliders" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "All Final File Formats" },
      { feature: "Dedicated Account Manager" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "2",
    title: "Corporate Combo Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "2000",
    actualPrice: "4000",
    featuresList: [
      { feature: "3 Initial Logo Concepts" },
      { feature: "8 Dedicated Designers" },
      { feature: "Icon Design" },
      { feature: "2 Free Custom Stationary Designs" },
      { feature: "MS Word Letterhead" },
      { feature: "Invoice Design" },
      { feature: "Product Catalog Design" },
      { feature: "Up to 20 Unique Pages Website" },
      { feature: "Add More Pages Yourself via CMS" },
      { feature: "Conceptual and Dynamic Website" },
      { feature: "Content Management System (CMS)" },
      { feature: "Easy Product Search" },
      { feature: "Product Reviews" },
      { feature: "Unlimited Products" },
      { feature: "Unlimited Categories" },
      { feature: "Promotional Product Showcase" },
      { feature: "New Product Showcase" },
      { feature: "Full Shopping Cart Integration" },
      { feature: "Payment Module Integration" },
      { feature: "Sales & Inventory Management" },
      { feature: "Custom Forms" },
      { feature: "Lead Capturing Forms (Optional)" },
      { feature: "Newsfeed Integration" },
      { feature: "Social Media Integration" },
      { feature: "Team of Dedicated Designers, Developers and Brand Experts" },
      { feature: "20 Stock images" },
      { feature: "6 Unique Banner Designs" },
      { feature: "jQuery Slider" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "Pinterest Page Design" },
      { feature: "All Final File Formats" },
      { feature: "Dedicated Account Manager" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "3",
    title: "Elite Combo Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "3000",
    actualPrice: "6000",
    featuresList: [
      { feature: "Complete Custom Design & Development" },
      { feature: "Client/User Dashboard Area" },
      { feature: "Custom Coding" },
      { feature: "Custom PHP Development" },
      { feature: "Content Management System (CMS)" },
      {
        feature:
          "Online Appointment/Scheduling/Online Ordering Integration (Optional)",
      },
      { feature: "Online Payment Integration (Optional)" },
      { feature: "Multi Lingual (Optional)" },
      { feature: "Custom Dynamic Forms (Optional)" },
      { feature: "Signup Area (For Newsletters, Offers etc.)" },
      { feature: "Search Bar" },
      { feature: "Live Feeds of Social Networks integration (Optional)" },
      { feature: "Mobile Responsive Web" },
      { feature: "Module-wise Architecture" },
      { feature: "Extensive Admin Panel" },
      { feature: "Award Winning Team of Expert Designers and Developers" },
      { feature: "Complete Deployment" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "4",
    title: "Basic Combo Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "450",
    actualPrice: "900",
    featuresList: [
      { feature: "5 Custom Logo Design Concepts" },
      { feature: "By 2 Designers" },
      { feature: " Icon Design" },
      { feature: "Business Card, Letterhead, Envelope, Fax Template" },
      { feature: "MS Word Letterhead" },
      { feature: "5 Page Website" },
      { feature: "Mobile Responsive" },
      { feature: "Team of Expert Designers & Developers" },
      { feature: "8 Stock images" },
      { feature: "5 Banner Designs" },
      { feature: "jQuery Sliders" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Complete Deployment" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "All Final File Formats" },
      { feature: "Dedicated Account Manager" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "5",
    title: "Startup Combo Package",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "1000",
    actualPrice: "2000",
    featuresList: [
      { feature: "3 Initial Logo Concepts" },
      { feature: "+ Social Media Design" },
      { feature: "Mobile Responsive" },
      { feature: "3 Dedicated Designers" },
      { feature: "Icon Design" },
      { feature: "Business Card, Letterhead, Envelope" },
      { feature: "MS Word Letterhead" },
      { feature: "Up to 15 Unique Pages Website" },
      { feature: "Add More Pages Yourself via CMS" },
      { feature: "Content Management System (CMS)" },
      { feature: "5 Stock Photos + 3 Banner Designs" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Complete Deployment" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "All Final File Formats" },
      { feature: "Dedicated Account Manager" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
];

export default ComboPackagesData;
